import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Mutation, NfcCard } from 'graphql/generated/graphqlTypes';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

dayjs.extend(utc);

export function mockedBlockNfcCardData(blockNfcCard: NfcCard): Pick<Mutation, 'blockNfcCard'> {
  return {
    blockNfcCard
  };
}

export const mockedBlockNfcCardDataForMutation = mockedBlockNfcCardData({
  name: '#0000000001',
  uuid: '#0000000001',
  updateRequired: false,
  __typename: 'NfcCard',
  assignment: {
    expiryDate: dayjs().utc().subtract(1, 'day').toISOString(),
    expired: true,
    blocked: { since: dayjs().utc().toISOString(), reason: 'Lost card' },
    visitor: generateMockVisitor({
      id: '1',
      name: 'Dennis Tegelwerker',
      email: 'd.tegelwerker@tkhsecurity.com',
      expirationDate: dayjs().utc().add(1, 'year').toISOString()
    }),
    visitorName: 'Dennis Tegelwerker'
  }
});
